import React from 'react'
import {
  Switch,
  Route,
  useLocation
} from "react-router-dom";

import Generate from './views/Generate'
import Form from './views/Form'

function usePageViews() {
  let location = useLocation();
  React.useEffect(() => {
    // fetch().send(["pageview", location.pathname]);
    console.log(location.pathname)
  }, [location]);
}

function App() {
  usePageViews()
  return (
    <div className="App">
      <Switch>
        <Route exact path='/'>
          <Form importComponent='HomeType.json'/>
        </Route>
        <Route path='/generate'>
          <Generate/>
        </Route>
      </Switch>
    </div>
  );
}

export default App;
